<div class="search-bar-container">
  <input type="text" [formControl]="searchControl" [placeholder]="placeholder" (keydown.enter)="submitSearch()">
  <img [src]="'svg/search-gray.svg' | assetVersion" alt="search" class="search-icon" (click)="submitSearch()">
</div>
